import React from 'react';
import { Mail, Instagram, ShoppingBag } from 'lucide-react';
import '../styles/components/NavBar.css';

const NavBar = ({ activePage, setActivePage, isMenuOpen, toggleMenu }) => (
  <nav className="fixed top-0 left-0 right-0 z-50 w-full">
    <div className="w-full px-4">
      <div className="flex justify-between items-center h-16">
        <div className="flex items-center">
          <div className="text-xl font-black font-bison">&nbsp;</div>
        </div>
        
        {/* Desktop menu */}
        <div className="hidden md:flex items-center ml-auto">
          <button
            onClick={() => setActivePage('home')}
            className={`nav-button ${activePage === 'home' ? 'active' : ''}`}
          >
            HOME
          </button>
          <button
            onClick={() => setActivePage('shop')}
            className={`nav-button ${activePage === 'shop' ? 'active' : ''}`}
          >
            SHOP
          </button>
          <button
            onClick={() => setActivePage('instagram')}
            className={`nav-button ${activePage === 'instagram' ? 'active' : ''}`}
          >
            INSTA
          </button>
        </div>
        
        {/* Mobile menu button */}
        <div className="md:hidden">
          <button onClick={toggleMenu} className="hamburger">
            <div className={`burger-line ${isMenuOpen ? 'line1-active' : ''}`}></div>
            <div className={`burger-line ${isMenuOpen ? 'line2-active' : ''}`}></div>
            <div className={`burger-line ${isMenuOpen ? 'line3-active' : ''}`}></div>
          </button>
        </div>
      </div>
    </div>
    
    {/* Mobile menu */}
    <div className={`mobile-menu ${isMenuOpen ? 'block' : 'hidden'}`}>
      <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
        <button
          onClick={() => {setActivePage('home'); toggleMenu();}}
          className={`block w-full text-left px-3 py-2 ${activePage === 'home' ? 'text-yellow bg-black' : 'text-black'}`}
        >
          HOME
        </button>
        <button
          onClick={() => {setActivePage('shop'); toggleMenu();}}
          className={`block w-full text-left px-3 py-2 ${activePage === 'shop' ? 'text-yellow bg-black' : 'text-black'}`}
        >
          SHOP
        </button>
        <button
          onClick={() => {setActivePage('instagram'); toggleMenu();}}
          className={`block w-full text-left px-3 py-2 ${activePage === 'instagram' ? 'text-yellow bg-black' : 'text-black'}`}
        >
          INSTAGRAM
        </button>
      </div>
    </div>
  </nav>
);

export default NavBar; 